import Plyr from 'plyr';
import 'plyr/dist/plyr.css'

window.Plyr = Plyr;